import { addDoc, collection, deleteDoc, deleteField, doc, getDoc, getDocs, orderBy,
  query, setDoc, updateDoc, where, getCountFromServer,arrayUnion } from "firebase/firestore";
import { db } from "../firebase";
import { Company, CompanyItemMaping } from "../model/Companies";
import { Groups } from "../model/Groups";
import { OnlineUrls } from "../model/OnlineUrls";
import { ReplyButton } from "../model/ReplyButton";
import { MenuSettings } from "../model/MenuSettings";
import { SystemMenus } from "../model/SystemMenus";
import { LinkMenus } from "../model/LinkMenus";
import { VideoMenus } from "../model/VideoMenus";
import { VideoCategorys } from "../model/VideoCategorys"
import { VideoContents, VideoContentsTimestampToDate } from "../model/VideoContents";
import { PhoneContact, PhoneContactTimestampToDate } from "../model/PhoneContact";
import { SystemSetting } from "../model/SystemSetting";
import { MatchingSetting } from "../model/MatchingSetting";
import { MatchingRequest } from "../model/MatchingRequest";
import { OptionContract, optionContractTimestampToDate } from "../model/OptionContract";
import { SearchKeys, KeyValues} from "../model/SearchKeys";
import { Staff } from "../model/Staff";


const companiesQuery = {
  //団体リストを取得
  getCompaniesList: async () => {
    console.log("companies getCompaniesList access");
    const companiesRef = await getDocs(collection(db, "companies"));
    return companiesRef.docs.map((doc) => CompanyItemMaping(doc.data() as Company));
  },
  //指定した団体を取得
  getCompany: async (tenantId: string) => {
    console.log("companies getCompany access");
    try {
      const companiesRef = await getDoc(doc(db, "companies", tenantId));
      return CompanyItemMaping(companiesRef.data() as Company);
    } catch (err: any) {
      console.error(err);
      return err
    }
  },
  // 団体のグループ取得
  getGroups: async (id: string): Promise<Groups[]> => {
    console.log("companies getGroups access");
    const groupRef = await getDocs(
      query(collection(db, `companies/${id}/groups`),
        orderBy('nameKana', 'asc')));
    return groupRef.docs.map((doc) => doc.data() as Groups);
  },
  // 団体別にグループ取得
  getTenantGroups: async (tenantId: string): Promise<Groups[]> => {
    console.log("companies getTenantGroup access");
    try {
      const groupRef = await getDocs(collection(db, `companies/${tenantId}/groups`));
      return groupRef.docs.map((doc) => doc.data() as Groups);
    } catch (err: any) {
      console.error(err);
      return [];
    }
  },
  // 団体グループ登録
  addGroup: async (tenantId: string, group: Groups): Promise<Groups | string> => { 
    try {
      const docRef = doc(collection(db, `/companies/${tenantId}/groups`));
      group.id = docRef.id;
      await setDoc(docRef, group);
      return group;
    } catch (err: any) {
      console.error(err);
      return "error";
    }
  },
  //指定したグループを取得
  getGroup: async (tenantId: string, groupId: string) => {
    console.log("companies getGroup access");
    const ref = await getDoc(doc(db, `/companies/${tenantId}/groups/${groupId}`));
    return ref.data() as Groups;
  },
  // 団体グループ更新
  updateGroup: async (tenantId: string, group: Groups): Promise<void> => {
    console.log("companies updateGroup access");
    try {
      const ref = doc(db, `/companies/${tenantId}/groups/${group.id}`);
      console.debug("companies updateGroup payload:", { tenantId, id: group.id, group });

      // 無効な日付値によるFirestoreシリアライズエラーを回避するため、サニタイズ済みペイロードを構築
      const sanitizeDate = (value: any): Date | undefined => {
        if (value instanceof Date) {
          if (isNaN(value.getTime())) return undefined;
          return value;
        }
        if (typeof value === 'number') {
          const d = new Date(value);
          return isNaN(d.getTime()) ? undefined : d;
        }
        if (typeof value === 'string') {
          const d = new Date(value);
          return isNaN(d.getTime()) ? undefined : d;
        }
        return undefined;
      };

      const payload: any = {};
      if (typeof group.name !== 'undefined') payload.name = group.name;
      if (typeof group.nameKana !== 'undefined') payload.nameKana = group.nameKana;
      if (typeof group.explanation !== 'undefined') payload.explanation = group.explanation;
      if (typeof group.userCount !== 'undefined') payload.userCount = group.userCount;
      if (typeof group.adminCount !== 'undefined') payload.adminCount = group.adminCount;
      if (typeof group.groupColor !== 'undefined') payload.groupColor = group.groupColor;
      if (typeof group.deleteFlg !== 'undefined') payload.deleteFlg = group.deleteFlg;

      // 有効な日付を優先、updateAtは現在時刻を設定、createAtは無効なら省略
      const createAtDate = sanitizeDate((group as any).createAt);
      if (createAtDate) payload.createAt = createAtDate;
      else if ((group as any).createAt !== undefined) {
        console.warn('companies updateGroup: invalid createAt, skipping field', (group as any).createAt);
      }

      const updateAtDate = sanitizeDate((group as any).updateAt) ?? new Date();
      payload.updateAt = updateAtDate;

      console.debug('companies updateGroup sanitized payload:', payload);
      await updateDoc(ref, payload);
      try {
        const updated = await getDoc(ref);
        console.debug("companies updateGroup result:", updated.exists() ? updated.data() : null);
      } catch (readErr) {
        console.error("companies updateGroup: failed to read back document", readErr);
      }
    } catch (err: any) {
      console.error(err)
    }
  },
  // 返信ボタン一覧取得
  getReplyButtons: async (companyId: string): Promise<ReplyButton[]> => {
    console.log("companies getReplyButtons access");
    const replyButtonsRef = await getDocs(
      query(collection(db, `companies/${companyId}/replyButtons`),
      orderBy('createAt', 'asc')));
    const replyButtons = replyButtonsRef.docs.map(
      (replyButton) => replyButton.data() as ReplyButton);
    return replyButtons;
  },
  // 返信ボタン作成
  setReplyButton: async (companyId: string, replyButton: ReplyButton):
    Promise<void> => {
    console.log("companies setReplyButtons access");
    try {
      const resolve = await addDoc(
        collection(db, `companies/${companyId}/replyButtons`),
        replyButton);
      await updateDoc(resolve, {id: resolve.id});
    } catch (err: any) {
      console.error(err);
    }
  },
  // 返信ボタン更新
  updateReplyButton: async (companyId: string, replyButton: ReplyButton):
    Promise<void> => {
    console.log("companies updateReplyButtons access");
    try {
      await updateDoc(
        doc(db, `companies/${companyId}/replyButtons/${replyButton.id}`),
        replyButton);
    } catch (err: any) {
      console.error(err);
    }
  },
  // 返信ボタン削除
  deleteReplyButton: async (companyId: string, documentId: string):
    Promise<void> => {
    console.log("companies deleteReplyButton access");
    try {
      await deleteDoc(doc(db, `companies/${companyId}/replyButtons/${documentId}`));
    } catch (err: any) {
      console.error(err);
    }
  },
  // ミーティングURL一覧取得
  getOnlineUrls: async (companyId: string): Promise<OnlineUrls[]> => {
    console.log("companies getOnlineUrls access");
    const onlineUrlsRef = await getDocs(
      query(collection(db, `companies/${companyId}/onlineUrls`),
      ...[orderBy('type', 'asc'), orderBy('name', 'asc')]));
    return onlineUrlsRef.docs.map((url) => url.data() as OnlineUrls);
  },
  // ミーティングURL登録
  setOnlineUrl: async (companyId: string, onlineUrl: OnlineUrls):
    Promise<void> => {
    console.log("companies setOnlineUrl access");
    try {
      const resolve = await addDoc(
        collection(db, `companies/${companyId}/onlineUrls`),
        onlineUrl);
      await updateDoc(resolve, {id: resolve.id});
    } catch (err: any) {
      console.error(err);
    }
  },
  // ミーティングURL更新
  updateOnlineUrl: async (companyId: string, onlineUrl: OnlineUrls):
    Promise<void> => {
    console.log("companies updateOnlineUrl access");
    try {
      await updateDoc(
        doc(db, `companies/${companyId}/onlineUrls/${onlineUrl.id}`),
        onlineUrl);
    } catch (err: any) {
      console.error(err);
    }
  },
  // ミーティングURL削除
  deleteOnlineUrl: async (companyId: string, documentId: string):
    Promise<void> => {
    console.log("companies deleteOnlineUrl access");
    try {
      deleteDoc(doc(db, `companies/${companyId}/onlineUrls/${documentId}`));
    } catch (err: any) {
      console.error(err);
    }
  },
  // メニュー設定取得
  getMenuSettings: async (companyId: string): Promise<MenuSettings[]> => {
    console.log("companies getMenuSettings access");
    const menuSettingsRef = await getDocs(
      query(
        collection(db, `companies/${companyId}/menuSettings`),
        orderBy('displayOrder', 'asc')
      )
    );
    return menuSettingsRef.docs.map((doc) => doc.data() as MenuSettings);
  },
  // メニュー設定一覧登録・更新
  upsertMenuSettings: async (companyId: string, menuSettings: MenuSettings[]):
    Promise<MenuSettings[]> => {
    console.log("companies upsertMenuSettings access");
    try {
      const resolve = await Promise.all(menuSettings.map(async (menu) => {
        return await companiesQuery.upsertMenuSetting(companyId, menu);
      }));
      return resolve.sort((a, b) => Number(a.displayOrder) - Number(b.displayOrder));
    } catch (err: any) {
      console.error(err);
      return [];
    }
  },
  // メニュー設定登録・更新
  upsertMenuSetting: async (companyId: string, menuSetting: MenuSettings):
    Promise<MenuSettings> => {
    console.log("companies upsertMenuSetting access");
    try {
      if(menuSetting.id === '' || menuSetting.id === undefined){
        const setResolve = await addDoc(
          collection(db, `companies/${companyId}/menuSettings`),
          menuSetting);
        await updateDoc(setResolve, {id: setResolve.id})
        const doc = await getDoc(setResolve);
        return {
          id: setResolve.id,
          displayOrder: doc.data()?.displayOrder,
          enableFlag: doc.data()?.enableFlag,
          menuType: doc.data()?.menuType,
          menuNo: doc.data()?.menuNo,
        } as MenuSettings;
      } else {
        await updateDoc(
          doc(db, `companies/${companyId}/menuSettings/${menuSetting.id}`),
          menuSetting);
        return menuSetting;
      }
    } catch (err) {
      console.error(err);
      return {
        id: "",
        displayOrder: "0",
        enableFlag: false,
        menuType: undefined,
        menuNo: "",
      }
    }
  },
  // メニュー設定削除
  deleteMenuSetting: async (companyId: string, menuId: string):
    Promise<boolean> => {
    console.log("companies deleteMenuSetting access");
    try {
      await deleteDoc(doc(db, `companies/${companyId}/menuSettings/${menuId}`));
      return true;
    } catch (err: any) {
      return false;
    }
  },
  // システム設定取得
  getSystemSetting: async (companyId: string):
    Promise<SystemSetting> => {
    console.log("companies getSystemSetting access");
    const docRef = await getDocs(collection(db, `companies/${companyId}/systemSetting`));
    return docRef.docs.map((doc) => doc.data() as SystemSetting)[0];
  },
  // システム設定登録・更新
  upsertSystemSetting: async (companyId: string, systemSetting: SystemSetting):
    Promise<SystemSetting | any> => {
    console.log("companies upsertSystemSetting access");
    try {
      const isUpdate = (systemSetting.id !== undefined && systemSetting.id !== '');
      const updateValue = {
        id: systemSetting.id ?? '',
        subTitle: systemSetting.subTitle ?? deleteField(),
        image: systemSetting.image ?? deleteField(),
        colorTheme: systemSetting.colorTheme ?? deleteField(),
        mypageDispFlg: systemSetting.mypageDispFlg ?? deleteField(),
        codeDispFlg: systemSetting.codeDispFlg ?? deleteField()
      };
      const docRef = isUpdate
        ? doc(db, `companies/${companyId}/systemSetting/${systemSetting.id}`)
        : await addDoc(collection(db, `companies/${companyId}/systemSetting`), systemSetting);
      await updateDoc(docRef, isUpdate ? updateValue : {id: docRef.id});
      const result = await getDoc(docRef);
      return result.data() as SystemSetting;
    } catch(err: any) {
      console.error(err);
      return err;
    }
  },
  // システムメニュー一覧取得
  getSystemMenusList: async (companyId: string):
    Promise<SystemMenus[]> => {
    console.log("companies getSystemMenusList access");
    const sustemMenusRef = await getDocs(
      collection(db, `companies/${companyId}/systemMenus`));
    return sustemMenusRef.docs.map((doc) => doc.data() as SystemMenus);
  },
  // システムメニュー取得
  getSystemMenus: async (companyId: string, id: string):
    Promise<SystemMenus> => {
    console.log("companies getSystemMenus access");
    const sustemMenusRef = await getDoc(
      doc(db, `companies/${companyId}/systemMenus/${id}`));
    return sustemMenusRef.data() as SystemMenus;
  },
  // システムメニュー更新
  updateSystemMenus: async (companyId: string, systemMenu: SystemMenus):
    Promise<void> => {
    console.log("companies updateSystemMenus access");
    try {
      await updateDoc(
        doc(db, `companies/${companyId}/systemMenus/${systemMenu.id}`),
        systemMenu);
    } catch (err: any){
      console.error(err);
    }
  },
  // 動画カテゴリー一覧取得
  getVideoCategoriesList: async (companyId: string):
    Promise<VideoCategorys[]> => {
    console.log("companies VideoCategories access");
    const videoCategorysRef = await getDocs(
      query(
        collection(db, `companies/${companyId}/videoCategories`),
        orderBy('displayOrder', 'asc')
      )
    );
    return videoCategorysRef.docs.map((doc) => doc.data() as VideoCategorys);
  },
  // 動画カテゴリー更新
  updateVideoCategories: async (companyId: string, videoCategories: VideoCategorys):
    Promise<void> => {
    console.log("companies updateVideoCategories access");
    try {
      await updateDoc(
        doc(db, `companies/${companyId}/videoCategories/${videoCategories.id}`),
        videoCategories);
    } catch (err: any) {
      console.error(err);
    }
  },
  // 動画カテゴリー一覧登録・更新
  upsertVideoCategories: async (companyId: string, videoCategorys: VideoCategorys[]):
    Promise<VideoCategorys[]> => {
    console.log("companies upsertVideoCategories access");
    try {
      const resolve = await Promise.all(videoCategorys.map(async (menu) => {
        return await companiesQuery.upsertVideoCategory(companyId, menu);
      }));
      return resolve.sort((a, b) => Number(a.displayOrder) - Number(b.displayOrder));
    } catch (err: any) {
      console.error(err);
      return [];
    }
  },
  // 動画カテゴリー一覧登録・更新
  upsertVideoCategory: async (companyId: string, videoCategorys: VideoCategorys):
    Promise<VideoCategorys> => {
    console.log("companies upsertVideoCategory access");
    try {
      if(videoCategorys.id === '' || videoCategorys.id === undefined){
        const setResolve = await addDoc(
          collection(db, `companies/${companyId}/videoCategories`),
          videoCategorys);
        await updateDoc(setResolve, {id: setResolve.id})
        const doc = await getDoc(setResolve);
        return {
          id: setResolve.id,
          displayOrder: doc.data()?.displayOrder,
          title: doc.data()?.title,
          type: doc.data()?.type,
        } as VideoCategorys;
      } else {
        await updateDoc(
          doc(db, `companies/${companyId}/videoCategories/${videoCategorys.id}`),
          videoCategorys);
        return videoCategorys;
      }
    } catch (err) {
      console.error(err);
      return {
        id: "",
        displayOrder: "0",
        title: "",
        type: "municipality",
        createUser: "",
        createAt: new Date(),
      }
    }
  },
  // 動画カテゴリー登録
  setVideoCategories: async (companyId: string, videoCategories: VideoCategorys):
    Promise<string> => {
    console.log("companies setVideoCategories access");
    try {
      const resolve = await addDoc(
        collection(db, `companies/${companyId}/videoCategories`),
        videoCategories);
      await updateDoc(resolve, {id: resolve.id});
      return resolve.id;
    } catch (err: any) {
      console.error(err);
      return err;
    }
  },
  // 動画カテゴリー削除
  deleteVideoCategory: async (companyId: string, documentId: string):
    Promise<void> => {
    console.log("companies deleteVideoCategory access");
    try {
      deleteDoc(doc(db, `companies/${companyId}/videoCategories/${documentId}`));
    } catch (err: any) {
      console.error(err);
    }
  },
  // 動画メニュー一覧取得
  getVideoMenusList: async (companyId: string):
    Promise<VideoMenus[]> => {
    console.log("companies getVideoMenusList access");
    const videoMenusRef = await getDocs(
      collection(db, `companies/${companyId}/videoMenus`));
    return videoMenusRef.docs.map((doc) => doc.data() as VideoMenus);
  },
  // 動画メニュー取得
  getVideoMenus: async (companyId: string, videoMenuId: string):
    Promise<VideoMenus> => {
    console.log("companies getVideoMenus access");
    const videoMenusRef = await getDoc(
      doc(db, `companies/${companyId}/videoMenus/${videoMenuId}`));
    return videoMenusRef.data() as VideoMenus;
  },

  // 動画コンテンツ一覧取得
  getVideoContentsList: async (companyId: string):
    Promise<VideoContents[]> => {
    console.log("companies VideoContents access");
    const videoContentsRef = await getDocs(
        collection(db, `companies/${companyId}/videoContents`));
    return videoContentsRef.docs.map((doc) =>
      VideoContentsTimestampToDate(doc.data()) as VideoContents);
  },
  // 動画コンテンツ更新
  updateVideoContents: async (companyId: string, videoContents: VideoContents): Promise<void> => {
    console.log("companies updateVideoContents access");
    try {
      // undefined のフィールドを除外
      const cleanVideoContents = Object.fromEntries(
        Object.entries(videoContents).filter(([_, v]) => v !== undefined)
      );

      await updateDoc(
        doc(db, `companies/${companyId}/videoContents/${videoContents.id}`),
        cleanVideoContents
      );
    } catch (err: any) {
      console.error(err);
    }
  },
  // 動画コンテンツ登録
  setVideoContents: async (companyId: string, videoContents: VideoContents):
    Promise<void> => {
    console.log("companies setVideoContents access");
    try {
      const cleaned = Object.fromEntries(
        Object.entries(videoContents).filter(([_, v]) => v !== undefined)
      );
      const resolve = await addDoc(
        collection(db, `companies/${companyId}/videoContents`),
        cleaned
      );
      await updateDoc(resolve, {id: resolve.id});
    } catch (err: any) {
      console.error(err);
    }
  },
  // 動画コンテンツ削除
  deleteVideoContents: async (companyId: string, documentId: string):
    Promise<void> => {
    console.log("companies deleteVideoContent access");
    try {
      deleteDoc(doc(db, `companies/${companyId}/videoContents/${documentId}`));
    } catch (err: any) {
      console.error(err);
    }
  },
  // 連携アプリ一覧取得
  getLinkMenusList: async (companyId: string): Promise<LinkMenus[]> => {
    console.log("companies getLinkMenusList access");
    const linkMenusRef = await getDocs(
      query(collection(db, `companies/${companyId}/linkMenus/`),
      ...[orderBy('type', 'asc'), orderBy('name', 'asc')]));
    const linkMenusData = linkMenusRef.docs.map((item) => item.data() as LinkMenus);
    return linkMenusData;
  },
  // 連携アプリ取得
  getLinkMenus: async (companyId: string, linkMenusId: string): Promise<LinkMenus> => {
    console.log("companies getLinkMenus access");
    const linkMenusRef = await getDoc(doc(db, `companies/${companyId}/linkMenus/${linkMenusId}`));
    return linkMenusRef.data() as LinkMenus;
  },
  // 連携アプリ登録
  setLinkMenus: async (companyId: string, linkMenus: LinkMenus): Promise<void> => {
    console.log("companies setLinkMenus access");
    try {
      const resolve = await addDoc(
        collection(db, `companies/${companyId}/linkMenus`),
        linkMenus);
      await updateDoc(resolve, {id: resolve.id});
    } catch (err: any) {
      console.error(err);
    }
  },
  // 連携アプリ更新
  updateLinkMenus: async (companyId: string, linkMenus: LinkMenus): Promise<void> => {
    console.log("companies updateLinkMenus access");
    try {
      await updateDoc(
        doc(db, `companies/${companyId}/linkMenus/${linkMenus.id}`),
        linkMenus
      );
    } catch (err: any) {
      console.error(err)
    }
  },
  // 連携アプリ削除
  deleteLinkMenus: async (companyId: string, linkMenus: LinkMenus): Promise<void> => {
    console.log("companies deleteLinkMenus access");
    try {
      deleteDoc(doc(db, `companies/${companyId}/linkMenus/${linkMenus.id}`));
    } catch (err: any) {
      console.error(err)
    }
  },
  // メニューNoからメニュー設定削除
  deleteMenuSettingByMenuNo: async (companyId: string, menuNo: string):
    Promise<boolean> => {
    console.log("companies deleteMenuSettingByMenuNo access");
    try {
      const docRef = await getDocs(query(collection(db, `companies/${companyId}/menuSettings`), where('menuNo', '==', menuNo)));
      await deleteDoc(doc(db, `companies/${companyId}/menuSettings/${docRef.docs[0].id}`));
      return true;
    } catch(err: any) {
      return false;
    }
  },
  // 問い合わせ先取得
  getPhoneContact: async (tenantId: string): Promise<PhoneContact | undefined> => {
    console.log("companies getPhoneContact access");
    try {
      const docsRef = await getDocs(collection(db, `companies/${tenantId}/phoneContact`));
      return docsRef.docs.map((doc) => PhoneContactTimestampToDate(doc.data()) as PhoneContact)[0];
    } catch (err: any) {
      console.error(err);
      return undefined;
    }
  },
  // 問い合わせ先登録
  addPhoneContact: async (tenantId: string, phoneContact: PhoneContact)
    : Promise<PhoneContact | undefined> => {
    console.log("companies addPhoneContact access");
    try {
      const docRef = await addDoc(
        collection(db, `companies/${tenantId}/phoneContact`), phoneContact);
      await updateDoc(docRef, {id: docRef.id});
      const result = await getDoc(docRef);
      return result.data() as PhoneContact;
    } catch (err: any) {
      console.error(err);
      return undefined;
    }
  },
  // 問い合わせ先更新
  updatePhoneContact: async (tenantId: string, phoneContact: PhoneContact)
    : Promise<boolean> => {
    console.log("companies updatePhoneContact access");
    try {
      await updateDoc(
        doc(db, `companies/${tenantId}/phoneContact/${phoneContact.id}`),
          phoneContact);
      return true;
    } catch (err: any) {
      console.error(err);
      return false;
    }
  },
  // ボランティア依頼設定取得
  getMatchingSetting: async (tenantId: string)
    : Promise<{success: boolean, data: MatchingSetting | any}> => {
    console.log("companies getMatchingSetting access");
    try{
      const docsRef = await getDocs(collection(db, `companies/${tenantId}/matchingSetting`));
      const result = docsRef.docs.map((doc) => doc.data() as MatchingSetting).at(0);
      if(result === undefined) {
        throw new Error();
      }
      return {success: true, data: result};
    } catch (err: any) {
      console.error(err);
      return {success: false, data: err};
    }
  },
  // ボランティア依頼内容取得
  getMatchingRequest: async (tenantId: string, requestId: string)
    : Promise<{success: boolean, data: MatchingRequest | any}> => {
    console.log("companies getMatchingRequest access");
    try{
      const docRef = await getDoc(doc(db, `companies/${tenantId}/matchingRequest/${requestId}`));
      const result = docRef.data() as MatchingRequest;
      return {success: true, data: result};
    } catch (err: any) {
      console.error(err);
      return {success: false, data: err};
    }
  },
  // ボランティア依頼内容追加
  addMatchingRequest: async (tenantId: string, request: MatchingRequest)
    : Promise<{success: boolean, data: MatchingRequest | any}> => {
    console.log("companies addMatchingRequest access");
    try {
      const docRef = await addDoc(collection(db, `companies/${tenantId}/matchingRequest`), request);
      await updateDoc(docRef, {id: docRef.id});
      const result = await getDoc(docRef);
      return {success: true, data: result.data() as MatchingRequest};
    } catch (err: any) {
      console.error(err);
      return {success: false, data: err};
    }
  },
  // ボランティア依頼内容更新
  updateMatchingRequest: async (tenantId: string, request: MatchingRequest)
    : Promise<{success: boolean, data: MatchingRequest | any}> => {
    console.log("companies updateMatchingRequest access");
    try {
      const docRef = doc(db, `companies/${tenantId}/matchingRequest/${request.requestId}`);
      await updateDoc(docRef, request);
      const result = await getDoc(docRef);
      return {success: true, data: result.data() as MatchingRequest};
    } catch (err: any) {
      console.error(err);
      return {success: false, data: err};
    }
  },
  // 運営者数の取得
  getAdminUserCount: async (companyId: string): Promise<number> => {
    console.log("companies getAdminUserCount access");
    const ref = await getCountFromServer(
      query(
        collection(db, `companies/${companyId}/users`),
        where('admin', '==', true),
        where('accountSuspensionFlg', '==', false)
      )
    );
    return ref.data().count;
  },
   // オプション契約一覧を取得
   getOptionContractList: async (tenantId: string): Promise<OptionContract[]> => {
    console.log("companies getOptionContractList access");
    try {
      const optionContractList: OptionContract[] = [];
      const option = await getDocs(collection(db, `companies/${tenantId}/optionContract`));
      option.docs.forEach((doc) => {
        const targetData = doc.data();
        optionContractList.push(optionContractTimestampToDate(targetData));
      });
      return optionContractList;
    } catch (err: any) {
      console.error(err);
      return [];
    }
  },
  // 団体別に検索キー取得
  getSearchKeys: async (companyId: string) => {
    console.log("searchKeys getSearchKeys access");
    const searchKeysRef = await getDocs(
      query(
        collection(db, `/companies/${companyId}/searchKeys`)
      )
    );
    return searchKeysRef.docs.map((doc) => doc.data() as SearchKeys);
  },
  // 指定された検索キーを取得
  getSearchKey: async (tenantId: string, searchKeysId: string): Promise<{success: boolean, data: SearchKeys | any}> => {
    console.log("companies getSearchKey access");
    try {
      const docRef = await getDoc(doc(db, `companies/${tenantId}/searchKeys/${searchKeysId}`));
      const result = docRef.data() as SearchKeys;
      return {success: true, data: result};
    } catch (err: any) {
      console.error(err);
      return {success: false, data: err};
    }
  },

  //検索キー更新
  updateSearchKeys: async (tenantId: string, searchKeysId: string, KeyValues: KeyValues[]) => {
    console.log("companies updateSearchKeys access");
    try {
      const docRef = doc(db, `companies/${tenantId}/searchKeys/${searchKeysId}`);
      await updateDoc(docRef, {
        keyValues: KeyValues,
        updateAt: new Date(),
      });
    } catch (error) {
      console.error("Error updating search key:", error);
      throw new Error("Search key update failed");
    }
  },

  // 検索キー追加
  createSearchKey: async (tenantId: string, newSearchKey: SearchKeys): Promise<SearchKeys> => {
    try {
      const collectionRef = collection(db, `companies/${tenantId}/searchKeys`);
      const docRef = await addDoc(collectionRef, newSearchKey);
      await updateDoc(docRef, {id:docRef.id})
      await getDoc(docRef);
      return {
        id: docRef.id,
        name: newSearchKey.name,
        keyValues: newSearchKey.keyValues,
        createAt: newSearchKey.createAt,
        updateAt: newSearchKey.updateAt,
      } as SearchKeys;
  
    } catch (error) {
      console.error("エラーが発生しました: ", error);
      throw error;
    }
  },

  //検索キー削除
  deleteSearchKeys: async (tenantId: string, searchKeysId: string, searchKey: string): Promise<boolean> => {
    console.log("systemParameters updateSearchKeys access");
    try {
      const searchKeyRef = doc(db, `companies/${tenantId}/searchKeys/${searchKeysId}`);
      const searchKeyDoc = await getDoc(searchKeyRef);         
      const searchKeyData = searchKeyDoc.data() as SearchKeys;
      const updatedKeyValues = searchKeyData.keyValues.filter(
        (keyValue) => keyValue.searchName !== searchKey
      );
      await updateDoc(searchKeyRef, {
        keyValues: updatedKeyValues,
        updateAt: new Date(),
      });
      return true; 
    } catch (err: any) {
      console.error(err);
      return false;
    }
  },
  
  // スタッフ一覧取得
  getStaffList: async (companyId: string): Promise<Staff[]> => {
    console.log("companies getStaffList access");
    const staffsRef = await getDocs(
      query(collection(db, `companies/${companyId}/staffs`)));
    return staffsRef.docs.map((staff) => staff.data() as Staff);
  },
};

export default companiesQuery;
